import axios from '../axios';
const END_POINT = '/sections';

const addSection = (section) => axios.post(`${END_POINT}`, section);
const getSections = (payload) => axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const getSection = (sectionId) => axios.get(`${END_POINT}/${sectionId}`);
const updateSection = (sectionId, payload) => axios.patch(`${END_POINT}/${sectionId}`, payload);
const searchSection = (payload) => axios.post(`${END_POINT}/search`, payload);
const searchSectionForCurrentUser = (payload) => axios.post(`${END_POINT}/search-for-current-user`, payload);
const deleteSection = (sectionsId) => axios.delete(`${END_POINT}/${sectionsId}`);

export {
    addSection,
    getSections,
    getSection,
    updateSection,
    searchSection,
    deleteSection,
    searchSectionForCurrentUser
}